import Vue from 'vue'
import dialogTmp from './template'

class dialog{
	constructor (){
		this.instances = null;
	}

	add (ins){
		this.instances = ins;
	}

	init (dom){
		this.instances.init(dom.innerHTML);
		return this;
	}

	open (){
		this.instances.active = true;
	}

	test (){

	}
}

let dialogIns = new dialog();

export default {
	install (){
		Vue.prototype.$bdDialog = dialogIns;
		Vue.component('bdDialog',dialogTmp);
	}
}



// WEBPACK FOOTER //
// ./src/components/common/bdDialog/index.js